import logo from "@/assets/logo-localnova.png";
import logoMark from "@/assets/logo-mark.png";

export { logo, logoMark };

export const NAV_LINKS = [
  { label: "What We Do", href: "#what-we-do" },
  { label: "Pricing", href: "#pricing" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export const CONTACT = {
  phone: "(516) 828-8042",
  phoneHref: "tel:+15168288042",
  email: "contact@LocalNova.digital",
  hours: "Open 24/7",
};

export function scrollToId(id) {
  const el = document.querySelector(id);
  if (!el) return;
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis) {
    lenis.scrollTo(el, { offset: -80, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
